export default "__VITE_ASSET__CWRVj3yb__"